export default __webpack_public_path__ + "static/media/info.54f09e8a.wav";